import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdditionalSignRedirectComponent } from './pages/additional-sign-redirect/additional-sign-redirect.component';
import { DipRedirectConfirmComponent } from './pages/dip-redirect-confirm/dip-redirect-confirm.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { NotFoundGuard } from './services/404.guard';
import { ClientAdditionsRedirectComponent } from './pages/client-additions-redirect/client-additions-redirect.component';
import { PUBLIC_ROUTES, BLOG_ROUTE } from './shared/constants';
import { EmailSigningComponent } from './pages/email-signing/email-signing.component';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/summary',
  },
  {
    path: BLOG_ROUTE,
    loadChildren: () => import('./modules/blog/blog.module').then(m => m.BlogModule)
  },
  {
    path: 'user',
    loadChildren: () => import('./modules/user/user.module').then(m => m.UserModule)
  },
  {
    path: 'videos',
    loadChildren: () => import('./modules/videos/videos.module').then(m => m.VideosModule)
  },
  {
    path: 'documents',
    loadChildren: () => import('./modules/documents/documents.module').then(m => m.DocumentsModule)
  },
  {
    path: 'about',
    loadChildren: () => import('./modules/about/about.module').then(m => m.AboutModule)
  },
  {
    path: 'dictionary',
    loadChildren: () => import('./modules/dictionary/dictionary.module').then(m => m.DictionaryModule)
  },
  {
    path: 'how-we-invest',
    loadChildren: () => import('./modules/how-we-invest/how-we-invest.module').then(m => m.HowWeInvestModule)
  },
  {
    path: 'model-portfolios',
    loadChildren: () => import('./modules/model-portfolios/model-portfolios.module').then(m => m.ModelPortfoliosModule)
  },
  {
    path: 'thematic-portfolios',
    loadChildren: () => import('./modules/thematic-portfolios/thematic-portfolios.module').then(m => m.ThematicPortfoliosModule)
  },
  {
    path: 'own-strategies',
    loadChildren: () => import('./modules/own-strategies/own-strategies.module').then(m => m.OwnStrategiesModule)
  },
  {
    path: 'calendar',
    loadChildren: () => import('./modules/business-calendar/business-calendar.module').then(m => m.BusinessCalendarModule)
  },
  {
    path: 'about-dip',
    loadChildren: () => import('./modules/about-dip/about-dip.module').then(m => m.AboutDipModule)
  },
  {
    path: 'notifications',
    loadChildren: () => import('./modules/notifications/notifications.module').then(m => m.NotificationsModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./modules/login/login.module').then(m => m.LoginModule)
  },
  {
    path: 'oauth/bcas/callback',
    loadChildren: () => import('./modules/oauth/oauth.module').then(m => m.OauthModule)
  },
  {
    path: 'cookie-text',
    loadChildren: () => import('./modules/cookie-text/cookie-text.module').then(m => m.CookieTextModule)
  },
  {
    path: 'summary',
    loadChildren: () => import('./modules/summary/summary.module').then(m => m.SummaryModule)
  },
  {
    path: 'investment-detail/:investmentId',
    loadChildren: () => import('./modules/investments/investments.module').then(m => m.InvestmentsModule)
  },
  {
    path: 'portfolio',
    loadChildren: () => import('./modules/portfolio/portfolio.module').then(m => m.PortfolioModule)
  },
  {
    path: 'strategy',
    loadChildren: () => import('./modules/strategy/strategy.module').then(m => m.StrategyModule)
  },
  {
    path: 'money',
    loadChildren: () => import('./modules/money/money.module').then(m => m.MoneyModule)
  },
  {
    path: PUBLIC_ROUTES.PUBLIC_INSTRUMENTS,
    loadChildren: () => import('./pages/public-instrument-list/public-instrument-list.module').then(m => m.PublicInstrumentListModule),
  },
  {
    path: 'dip-redirect/:token',
    component: DipRedirectConfirmComponent,
  },
  {
    path: 'dip-redirect',
    component: DipRedirectConfirmComponent,
  },
  {
    path: 'addition-redirect/:token',
    component: AdditionalSignRedirectComponent,
  },
  {
    path: 'addition-redirect',
    component: AdditionalSignRedirectComponent,
  },
  {
    path: PUBLIC_ROUTES.EMAIL_VERIFICATION + '/:token',
    component: EmailSigningComponent,
  },
  {
    path: PUBLIC_ROUTES.EMAIL_VERIFICATION,
    component: EmailSigningComponent,
  },
  {
    path: 'client-addition-redirect/:token',
    component: ClientAdditionsRedirectComponent,
  },
  {
    path: 'client-addition-redirect',
    component: ClientAdditionsRedirectComponent,
  },
  {
    path: '**',
    component: NotFoundComponent,
    canActivate: [NotFoundGuard],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(
      routes,
      {
        onSameUrlNavigation: 'reload',
        paramsInheritanceStrategy: 'emptyOnly',
      }
    ),
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
